module.exports = __webpack_public_path__ + "static/media/ShiftToPending.54d8a5b9.svg";